import CategoryColumn from './CategoryColumn';
import CategoryHorizontalCardRows from './CategoryHorizontalCardRows';
import CategoryTwoSides from './CategoryTwoSides';
import CategoryVerticalCardRows from './CategoryVerticalCardRows';
import CategoryVerticalList from './CategoryVerticalList';
var categoryVarianComponentMap = {
  VerticalList: CategoryVerticalList,
  Column: CategoryColumn,
  VerticalCardRow: CategoryVerticalCardRows,
  HorizontalCardRow: CategoryHorizontalCardRows,
  CategoryTwoSides: CategoryTwoSides
};
export { categoryVarianComponentMap };